// extracted by mini-css-extract-plugin
var _1 = "TaskComment_line__95d95";
var _2 = "TaskComment_root__c157a";
var _3 = "TaskComment_title__9b0f9";
export { _1 as "line", _2 as "root", _3 as "title" }
